import AddressForm from '@/components/profile/AddressForm.vue';
import AreYouSureModal from '@/components/graphics/AreYouSureModal.vue';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      customer: 'auth/customer',
      billingAddress: 'auth/billingAddress',
      isItaly: 'isItaly',
    }),
  },

  methods: {
    openEditModal(address) {
      const addressToEdit = address;
      this.$modal.show(AddressForm, {
        givenAddress: addressToEdit, editing: true, title: this.$t('addresses.edit'),
      }, { height: 'auto', adaptive: true });
    },

    areYouSureToDelete(addressId) {
      this.$modal.show(AreYouSureModal, {
        question: this.$t('addresses.areYouSure'),
        do_it: this.$t('addresses.delete'),
        addressToDeleteId: addressId,
      }, { height: 'auto', adaptive: true });
    },

    addAddress() {
      this.$modal.show(AddressForm, { isShipping: true, title: this.$t('addresses.add') }, { height: 'auto', adaptive: true });
    },

  },
};
